<template>
  <div class="view__view view-address">
    <div class="view__headline">
      <span class="heading beta -color-white">Wie lautet Ihre Anschrift?</span>
    </div>
    <div class="view__form form">
      <div class="field__wrap l-2col-b1-66-33">
        <div class="col col-one">
          <AutocompleteInput
              placeholder="Straße"
              identifier="street"
              :value="street" @update="street = $event"/>
        </div>
       <div class="col col-two">
         <TextInput identifier="number" placeholder="Hausnr" :value="number"
                    @update="number = $event"></TextInput>
       </div>
      </div>
      <div class="field__wrap l-2col-b1-33-66">
        <div class="col col-one">
          <TextInput identifier="zip" placeholder="PLZ" :value="zip"
                     @update="zip = $event"></TextInput>
        </div>
        <div class="col col-two">
          <AutocompleteInput
              placeholder="Stadt"
              identifier="city" :value="city" @update="city = $event"/>
        </div>
      </div>
    </div>
    <div class="cta-wrapper">
      <button class="-btn-beta" @click="handleSubmit"><span>Weiter zur Adressprüfung</span></button>
    </div>
    <LocationSelector
        :open="showOverlay"
        @updateView="updateView($event)"
        @closeOverlay="showOverlay = false"/>
  </div>
</template>

<script>
import { ref } from 'vue';
import TextInput from '@/components/Input/TextInput.vue';
import LocationSelector from '@/components/LocationSelector.vue';
import { useLocationStore } from '@/stores/location';
import AutocompleteInput from '@/components/Input/AutocompleteInput.vue';
import { useViewStore } from '@/stores/view';

export default {
  name: 'AddressEntry',
  components: {
    AutocompleteInput,
    TextInput,
    LocationSelector,
  },
  data() {
    return {
      showOverlay: false,
    };
  },
  methods: {
    handleSubmit() {
      if (this.street && this.zip && this.city) {
        this.getUniqueLocations();
        this.showOverlay = true;
      }
    },
    updateView(name) {
      this.view.update(name, this.view.counter + 1);
    },
  },
  setup() {
    const locations = useLocationStore();
    const view = useViewStore();
    const street = ref('');
    const number = '';
    const zip = '';
    const city = ref('');

    function getUniqueLocations() {
      locations.getUniqueLocations(
        this.street,
        this.number,
        this.zip,
        this.city,
      );
    }
    return {
      street,
      number,
      zip,
      city,
      view,
      getUniqueLocations,
    };
  },
};
</script>
